import {useExecuteModal} from "../../../../../hooks/useExecuteModal";
import React from "react";
import {Button, Tooltip} from "antd";
import {EditOutlined} from "@ant-design/icons";
import {FleetExpenseAction, FleetExpensesModel} from "../../../../../models/FleetExpenses/FleetExpensesModel";
import FleetExpensesStore from "../../../../../stores/FleetExpensesStore";
import FleetExpenseModal from "../../../../modals/fleetExpenses/FleetExpenseModal/FleetExpenseModal";

type EditExpenseButtonProps = {
  expense: FleetExpensesModel<'expense'>;
};

const EditExpenseButton = ({ expense }: EditExpenseButtonProps) => {
  const modalHandler = useExecuteModal();
  const onResult: FleetExpenseAction = (): void => {
    FleetExpensesStore.load({}, true);
  };

  return (
    <>
      <Tooltip placement="top" title="Edit expense">
        <Button style={{ width: '25px', aspectRatio: '1/1' }} type="primary" onClick={modalHandler.executeModal}>
          <EditOutlined />
        </Button>
      </Tooltip>
      <FleetExpenseModal onResult={onResult} edit={true} expense={expense} store={FleetExpensesStore} handler={modalHandler} />
    </>
  );
};

export default EditExpenseButton;